import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar, FaArrowRight } from 'react-icons/fa';

interface OfferCardProps {
  offer: {
    id: string;
    name: string;
    image: string;
    bonus: string;
    rating: number;
    features: string[];
    url?: string;
  };
}

const OfferCard: React.FC<OfferCardProps> = ({ offer }) => {
  return (
    <div className="glass rounded-xl overflow-hidden hover:border-accent-primary transition-all transform hover:scale-105 group">
      <div className="relative p-8">
        <img
          src={offer.image}
          alt={offer.name}
          className="w-full h-48 object-contain"
          loading="lazy"
          decoding="async"
          width="400"
          height="192"
        />
        <div className="absolute top-4 right-4 bg-accent-primary text-white px-3 py-1 rounded-full text-sm font-bold">
          {offer.bonus}
        </div>
      </div>
      <div className="p-6">
        <h3 className="text-2xl font-bold mb-2">{offer.name}</h3>
        <div className="flex items-center gap-2 mb-4">
          <div className="flex text-accent-primary">
            {[...Array(5)].map((_, i) => (
              <FaStar
                key={i}
                className={i < Math.floor(offer.rating) ? 'fill-current' : 'text-gray-600'}
                size={16}
              />
            ))}
          </div>
          <span className="text-gray-400">{offer.rating}/5</span>
        </div>
        <ul className="space-y-2 mb-6">
          {offer.features.map((feature, index) => (
            <li key={index} className="text-gray-400 flex items-center gap-2">
              <span className="text-accent-primary">✓</span> {feature}
            </li>
          ))}
        </ul>
        <div className="flex flex-col gap-3">
          {offer.url && (
            <a
              href={offer.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full bg-gradient-to-r from-accent-primary to-accent-secondary text-white font-bold py-3 px-6 rounded-lg hover:shadow-lg hover:shadow-accent-primary/50 transition-all flex items-center justify-center gap-2 group-hover:gap-3"
            >
              Claim Bonus <FaArrowRight />
            </a>
          )}
          <Link
            to={`/offers/${offer.id}`}
            className="w-full glass text-white font-semibold py-3 px-6 rounded-lg hover:bg-accent-primary hover:text-white transition-all flex items-center justify-center gap-2"
          >
            Read Review <FaArrowRight />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OfferCard;

